<template>
  <v-card>
    <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>
    <v-form
      @submit.prevent="submitForm"
      class="card_container mx-auto"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1"
      >
        {{ alertValidate }}</v-alert
      >
      <div class="mx-2">
        <div v-for="field in sortedFields" :key="field.name" class="inputs">
          <component
            :is="getComponentName(field.type)"
            :name="field.name"
            v-model="field.data"
            :label="field.label"
            :rules="field.rules"
            outlined
            dense
            :items="field.items"
            item-text="text"
            item-value="id"
            :multiple="field.type === 'autocomplete'"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                id="chip-label"
                small
                v-if="field.type === 'autocomplete'"
                :color="item.color || 'grey'"
                parameters
                close
                @click:close="field.data.splice(index, 1)"
              >
                {{ item.text }}
              </v-chip>
              <p class="ma-0" v-else>
                {{ item.text }}
              </p>
            </template>
            <template v-slot:item="{ item }">
              <v-chip
                v-if="field.type === 'autocomplete'"
                id="chip-label"
                small
                :color="item.color || 'grey'"
              >
                {{ item.text }}
              </v-chip>
              <p class="ma-0" v-else>
                {{ item.text }}
              </p>
            </template>
          </component>
        </div>
      </div>
      <v-col class="ma-0 pa-0">
        <table-with-search
          :title="title"
          :headers="allHeaders"
          :items="itemsTable"
          :openDialog="openDialogReports"
          @headersUpdated="updateHeaders"
        />
      </v-col>
      <div class="d-flex justify-space-between pt-4 mx-2">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
    <v-dialog v-model="showParameters" max-width="500px" persistent>
      <v-card>
        <v-alert
          dense
          v-if="errorParams"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >
        <FormOrder
          :allFields="parameters.items"
          :mode="modeParameters"
          @save="saveFormReports"
          @cancel="resetReports"
          @itemUpdate="updateDataSelect"
        />
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import TableWithSearch from "../Complement/TableWithSearch.vue";
import FormOrder from "../Complement/FormOrder.vue";
import reports from "../../store/reportes/reports";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import { VSelect, VTextField, VAutocomplete } from "vuetify/lib";
import moment from "moment";
Vue.component("v-autocomplete", VAutocomplete);
Vue.component("v-text-field", VTextField);

export default {
  components: {
    TableWithSearch,
    FormOrder,
  },
  props: {
    allFields: Array,
    mode: String,
  },
  data() {
    return {
      items: {},
      valid: true,
      error: false,
      alertValidate: "",
      editItemIndex: null,
      title: this.$tc("reports.parameters"),
      showParameters: false,
      previousTypeData: null,
      itemsParameters: null,
      type: null,
      errorParams: false,
      selectedType: null,
    };
  },
  mounted() {
    reports.dispatch("getLookups");
    this.items = Vue.observable(this.allFields);
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.parametros;
    },
    lookups() {
      return reports.state.lookups.sort();
    },
    sortedFields() {
      return this.items.slice().sort((a, b) => a.order - b.order);
    },
    itemsTable: {
      get() {
        return reports.state.itemsTable;
      },
      set(value) {
        return value;
      },
    },
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "name",
            type: "text",
            label: "Nombre",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "type",
            type: "select",
            label: "Tipo",
            items: [
              { id: "number", text: "Número" },
              { id: "string", text: "Cadena" },
              { id: "char", text: "Cadena Fija" },
              { id: "date", text: "Fecha" },
              { id: "time", text: "Hora" },
              { id: "boolean", text: "Booleano" },
              { id: "list", text: "Lista un solo valor" },
              { id: "listMultiple", text: "Lista de múltiples valores" },
            ],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },
          {
            id: 3,
            show: false,
            data: null,
            name: "length",
            type: "text",
            typeInput: "number",
            label: "Longitud",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 5,
          },
          {
            id: 9,
            show: false,
            data: null,
            name: "values",
            type: "text",
            typeInput: "text",
            label:
              "Valores por defecto (escriba los valores separados por coma)",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 9,
          },
          {
            id: 4,
            show: false,
            data: null,
            name: "defaultValue",
            type: "text",
            label: "Default",
            order: 4,
            disabled: false,
          },
          {
            id: 5,
            show: false,
            data: "",
            name: "lookup",
            type: "select",
            label: "Lookup",
            items: this.lookups,
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 3,
          },
          {
            id: 6,
            show: false,
            data: null,
            name: "minValue",
            type: "text",
            typeInput: "number",
            label: "Minimo",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 6,
          },
          {
            id: 7,
            show: false,
            data: null,
            name: "maxValue",
            type: "text",
            typeInput: "number",
            label: "Maximo",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 7,
          },
          {
            id: 10,
            show: true,
            data: true,
            name: "required",
            type: "check",
            label: "Requerido",
            order: 10,
          },
          {
            id: 8,
            show: false,
            data: false,
            name: "today",
            type: "check",
            label: "Hoy",
            order: 8,
          },
          {
            id: 11,
            show: false,
            data: "",
            name: "lookupMultiple",
            type: "select",
            label: "Lookup Multiple",
            items: this.lookups,
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 3,
          },
        ],
      };
    },

    modeParameters: {
      get() {
        return reports.state.modeParameters;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  watch: {
    allFields: {
      immediate: true,
      handler(value) {
        this.items = value;
      },
    },
  },
  methods: {
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        parametros: headers,
      };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    getComponentName(type) {
      if (type === "select") {
        return "v-autocomplete";
      } else if (type === "text") {
        return "v-text-field";
      } else if (type === "char") {
        return "v-text-field";
      } else if (type === "autocomplete") {
        return "v-autocomplete";
      }
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();
      this.sendFormComplete(itemsComplete);
    },
    sendFormComplete(items) {
      const operidOwner = localStorage.getItem("operId");
      let tagsArray = [];
      if (items.tags.length > 0) {
        const tagsIdsArray = items.tags.split(",");
        tagsArray = tagsIdsArray.map((numString) => parseInt(numString, 10));
      }
      let payload = {
        name: items.name,
        description: items.description,
        process: items.process,
        type: items.type,
        operid: items.type == "Pr" ? operidOwner : 0,
        parameters: this.itemsParameters,
        tags: tagsArray,
      };
      this.$emit("save", payload);
      this.itemsParameters = undefined;
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    findTypeTable(type) {
      const items = [
        { id: "number", text: "Número" },
        { id: "string", text: "Cadena" },
        { id: "char", text: "Cadena Fija" },
        { id: "date", text: "Fecha" },
        { id: "time", text: "Hora" },
        { id: "boolean", text: "Booleano" },
        { id: "list", text: "Lista un solo valor" },
        { id: "listMultiple", text: "Lista de múltiples valores" },
      ];
      const foundType = items.find((item) => item.id === type);
      if (foundType) {
        return foundType.text;
      } else {
        return "Tipo no encontrado";
      }
    },
    saveFormReports(item) {
      let payload = {
        name: item.name,
        type: item.type,
        typeTable: this.findTypeTable(item.type),
        required: item.required == true ? item.required : false,
        requiredTable: item.required == true ? "✔️" : "",
        length: item.length == undefined ? 0 : item.length,
        lookup: item.lookup == undefined ? null : item.lookup,
        lookupMultiple:
          item.lookupMultiple == undefined ? null : item.lookupMultiple,
        defaultValue:
          item.type === "boolean"
            ? item.defaultValue === true || item.defaultValue === "true"
              ? "1"
              : "0"
            : item.type === "date"
            ? item.today == "true" || !item.defaultValue
              ? "**"
              : item.defaultValue
            : item.defaultValue,
        minValue: item.minValue == null ? undefined : item.minValue,
        maxValue: item.maxValue == null ? undefined : item.maxValue,
        values: item.values == undefined ? null : item.values,
      };
      const validationMessage = this.validateDefaultValue(payload);
      if (validationMessage) {
        this.showErrorParams(validationMessage);
      } else {
        switch (this.type) {
          case "add":
            this.addParameter(payload);
            break;
          case "edit":
            this.editParameter(payload);
            break;
          default:
            break;
        }
      }
    },
    validateDefaultValue(item) {
      const minValue = parseInt(item.minValue, 10);
      const maxValue = parseInt(item.maxValue, 10);
      const length = parseInt(item.length, 10);
      if (
        item.lookup == null &&
        item.type == "number" &&
        minValue !== undefined &&
        maxValue !== undefined
      ) {
        const defaultValue = parseFloat(item.defaultValue);
        if (minValue < 0 || maxValue < 0) {
          return `El valor minimo y maximo debe ser mayor a 0`;
        }

        if (!isNaN(defaultValue) || defaultValue !== "") {
          if (defaultValue < minValue || defaultValue > maxValue) {
            return `El valor por defecto debe estar entre ${minValue} y ${maxValue}`;
          }
        }
        if (minValue > maxValue) {
          return `El valor minimo ${minValue} debe ser menor al valor maximo ${maxValue}`;
        }
      } else if (item.type == "string" && length < item.defaultValue.length) {
        return `El valor por defecto debe tener ${item.length} caracteres`;
      } else {
        return null;
      }
    },

    addParameter(payload) {
      this.itemsParameters = this.itemsTable;
      const existingParameter = this.itemsParameters.find(
        (e) => e.name === payload.name
      );
      if (!existingParameter) {
        this.itemsParameters.push(payload);
        reports.commit("setItemsTable", this.itemsParameters);
        this.resetReports(false);
      } else {
        this.showErrorParams(this.$tc("reports.equalParam"));
      }
    },
    showErrorParams(text) {
      this.errorParams = true;
      this.alertValidate = text;
      setTimeout(() => {
        this.errorParams = false;
      }, 3500);
    },
    async editParameter(payload) {
      let index = this.editItemIndex;
      this.itemsParameters = JSON.parse(JSON.stringify(this.itemsTable));
      if (index >= 0 && index < this.itemsParameters.length) {
        const updatedItem = Object.assign({}, payload);
        this.itemsParameters[index] = updatedItem;
        this.$set(this.itemsTable, index, updatedItem);
      }
      await reports.commit("setItemsTable", this.itemsParameters);
      this.resetReports(false);
    },

    resetReports(value) {
      this.showParameters = value;
      this.parameters.items.forEach((e) => {
        e.type == "check" ? (e.data = false) : (e.data = true);
      });
      this.$refs.form.resetValidation();
      this.switchTypes({ data: null });
    },
    deleteParameter(payload) {
      this.itemsParameters = this.itemsTable.slice();
      const index = this.itemsParameters.findIndex(
        (e) => e.name === payload.name
      );
      if (index !== -1) {
        this.itemsParameters.splice(index, 1);
      }
      reports.commit("setItemsTable", this.itemsParameters);
    },
    openDialogReports(type, item) {
      this.type = type;
      this.parameters.items[0].data = "";
      this.parameters.items[4].data = "";
      this.parameters.items[4].show = false;
      switch (this.type) {
        case "add":
          this.showParameters = true;
          reports.commit(
            "setModeParameters",
            this.$tc("reports.addParameters")
          );
          break;
        case "edit":
          this.showParameters = true;
          reports.commit(
            "setModeParameters",
            this.$tc("reports.editParameters")
          );
          this.editItemIndex = item.index;
          this.updateEdit(item);
          type == "char" &&
            element.label == "Valores(escriba los valores separados por coma)";

          break;
        case "delete":
          this.deleteParameter(item);
          break;

        default:
          break;
      }
    },
    updateEdit(item) {
      this.parameters.items.forEach((element) => {
        if (element.name === "today") {
          if (item.type === "date" && item.defaultValue === "**") {
            element.show = true;
            element.data = true;
          } else {
            element.data = !!item.today;
            element.show = item.type === "date";
          }
          return;
        }
        if (element.name === "defaultValue") {
          element.show = true;
          if (item.type === "number") {
            element.type = "number";
            element.typeInput = "number";
          } else if (item.type === "date") {
            element.type = "date";
            element.typeInput = "date";
          } else if (item.type === "time") {
            element.type = "time";
            element.typeInput = "time";
          } else if (item.type === "boolean") {
            element.type = "boolean";
            element.typeInput = "checkbox";
            element.data = item.defaultValue === "1"; // Asegurar que sea booleano
          } else {
            element.type = "text";
            element.typeInput = "text";
          }

          if (item.defaultValue === "**" && item.type === "date") {
            element.data = moment().format("DD-MM-YYYY");
          } else if (item.type !== "boolean") {
            element.data = item.defaultValue;
          }
          return;
        }
        element.data = item[element.name];
      });
    },

    updateDataSelect(item) {
      this.selectedType = item.data;
      if (item.name == "type") {
        this.switchTypes(item);
      }
      if (item.name == "today") {
        this.changeTypeToday(item);
      }
    },
    changeTypeToday(item) {
      const todayField = this.parameters.items.find(
        (field) => field.name === "today"
      );
      const defaultValueField = this.parameters.items.find(
        (field) => field.name === "defaultValue"
      );
      if (todayField.data) {
        defaultValueField.data = "**";
      } else {
        defaultValueField.data = "";
      }
      if (todayField && defaultValueField) {
        if (item.data === true && item.type === "check") {
          defaultValueField.disabled = true;
        } else {
          defaultValueField.disabled = false;
        }
      }
    },
    switchTypes() {
      const defaultValueField = this.parameters.items.find(
        (field) => field.name === "defaultValue"
      );
      defaultValueField.disabled = false;
      const typeToInputMapping = {
        string: "text",
        number: "number",
        date: "date",
        time: "time",
        boolean: "checkbox",
      };

      if (defaultValueField) {
        if (this.selectedType in typeToInputMapping) {
          defaultValueField.show = true;
          defaultValueField.typeInput = typeToInputMapping[this.selectedType];
        } else {
          defaultValueField.show = false;
        }
      }

      const typeMapping = {
        string: ["length"],
        list: ["lookup"],
        listMultiple: ["lookupMultiple"],
        number: ["minValue", "maxValue"],
        date: ["today"],
        time: ["time"],
        char: ["values"],
        boolean: ["checkbox"],
      };

      if (this.selectedType in typeMapping) {
        typeMapping[this.selectedType].forEach((typeToToggle) => {
          this.showTypeInput(true, typeToToggle);
        });
      }

      for (const type in typeMapping) {
        if (type !== this.selectedType) {
          typeMapping[type].forEach((typeToToggle) => {
            this.showTypeInput(false, typeToToggle);
          });
        }
      }

      this.previousTypeData = this.selectedType;
    },

    applyDefaultValueValidation() {
      const defaultValueField = this.parameters.items.find(
        (field) => field.name === "defaultValue"
      );
      defaultValueField.rules.push((v) => {
        return !this.validateDefaultValue({
          type: this.selectedType,
          defaultValue: v,
        });
      });
    },
    showTypeInput(show, type) {
      const index = this.parameters.items.findIndex((e) => e.name === type);

      if (index !== -1) {
        const field = this.parameters.items[index];
        field.show = show;
        if (!show) {
          field.data = this.getEmptyValueByType(field.typeInput);
        }
      }
    },
    getEmptyValueByType(typeInput) {
      switch (typeInput) {
        case "checkbox":
          return false;

        case "number":
          return 0;

        case "date":
        case "time":
        case "text":
        default:
          return "";
      }
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.card_container {
  max-width: 1500px;
}
#chip-label {
  color: #ffffff;
  text-shadow: 0px 1px 4px #000000be;
}
</style>
